
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.27 11A3.271 3.271 0 1111 7.729 3.267 3.267 0 0114.27 11z","fill":"none","stroke":"#8d98aa","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11 18.592c3.238 0 6.256-1.91 8.357-5.215a4.893 4.893 0 000-4.765c-2.1-3.304-5.118-5.214-8.357-5.214s-6.256 1.91-8.357 5.215a4.892 4.892 0 000 4.765c2.101 3.304 5.119 5.214 8.357 5.214z","fill":"none","stroke":"#8d98aa","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    